module.exports = __webpack_public_path__ + "919e8c799818f134062b385f7199e8f9.pdf";